import { useState } from "react";
import axios from "axios";
import { Heart, Loader2, MessageSquare } from "lucide-react";
import { API } from "../../config";

const T = {
  sk: { like: "Páči sa mi", liked: "Páči sa vám", comment: "Pripomienka", ph: "Čo by ste chceli zmeniť?", send: "Odoslať", sent: "Pripomienku sme dostali, ozveme sa.", err: "Nepodarilo sa odoslať." },
  cs: { like: "Líbí se mi", liked: "Líbí se vám", comment: "Připomínka", ph: "Co byste chtěli změnit?", send: "Odeslat", sent: "Připomínku jsme dostali, ozveme se.", err: "Nepodařilo se odeslat." },
};

export const PreviewFeedback = ({ token, item, lang }) => {
  const t = T[lang];
  const [liked, setLiked] = useState(item.liked);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [state, setState] = useState("idle");
  const send = async (action) => {
    setState("busy");
    try {
      await axios.post(`${API}/web-design/proposal/${token}/previews/${item.id}/feedback`, { action, text });
      if (action === "like") { setLiked(true); setState("idle"); } else { setText(""); setOpen(false); setState("sent"); }
    } catch { setState("error"); }
  };
  const id = item.id;
  return (
    <div className="px-3 pb-3" data-testid={`preview-feedback-${id}`}>
      <div className="flex gap-2">
        <button onClick={() => !liked && send("like")} disabled={liked || state === "busy"} className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-bold transition-colors ${liked ? "bg-[#a3e635] text-black" : "bg-white/10 text-white hover:bg-white/20"}`} data-testid={`preview-like-${id}`}>
          <Heart className={`w-4 h-4 ${liked ? "fill-black" : ""}`} />{liked ? t.liked : t.like}</button>
        <button onClick={() => setOpen(!open)} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-bold bg-white/10 text-white hover:bg-white/20 transition-colors" data-testid={`preview-comment-toggle-${id}`}>
          <MessageSquare className="w-4 h-4" />{t.comment}</button>
      </div>
      {open && (
        <div className="mt-2 space-y-2">
          <textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder={t.ph} className="w-full px-3 py-2 rounded-lg bg-white text-gray-900 placeholder-gray-400 text-sm outline-none border-2 border-transparent focus:border-[#a3e635]" data-testid={`preview-comment-text-${id}`} />
          <button onClick={() => send("comment")} disabled={text.trim().length < 3 || state === "busy"} className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[#a3e635] text-black text-sm font-black disabled:opacity-50" data-testid={`preview-comment-send-${id}`}>
            {state === "busy" && <Loader2 className="w-3 h-3 animate-spin" />}{t.send}</button>
        </div>)}
      {item.comments?.length > 0 && <ul className="mt-2 space-y-1 text-xs text-white/55">{item.comments.map((c, i) => <li key={i}>• {c}</li>)}</ul>}
      {state === "sent" && <p className="mt-2 text-sm text-[#d9f99d]" data-testid={`preview-comment-sent-${id}`}>{t.sent}</p>}
      {state === "error" && <p className="mt-2 text-sm text-red-300" data-testid={`preview-feedback-error-${id}`}>{t.err}</p>}
    </div>
  );
};
